import React, { useEffect } from 'react';
import { View, ScrollView } from 'react-native';
import i18n from 'i18n-js';

import { scale as initialScale, width } from '@components/frame';
import { Popup, formatTimeEvent, convertTimeLetter, isWeb } from '@helpers';

import AnimatedTable from '@components/settings/components/common/animatedTable';
import AnimatedHeader from '@components/common/AnimatedHeader';
import TouchableElement from '@components/common/touchableElement';

import Svg from '@styles/icons/svg';

import ClampingToolDetails from './clampingToolDetails';
import { font as initialFont } from '@styles/fonts';

export default ({
  C,
  clampingTools: { clampingTools, loaded },
  navigation,
  panelViewMode,
  scale = initialScale,
  font = initialFont,
  refetchTools,
  route,
}) => {
  const params = route?.params;

  useEffect(() => {
    if (navigation) {
      const unsubscribe = navigation.addListener('focus', () => {
        refetchTools?.();
      });

      return unsubscribe;
    }
  }, [navigation, refetchTools]);

  const ArrowComponent = () => {
    return (
      <View style={{ paddingTop: scale(5) }}>
        <Svg icon="chevronRightLight" color="Label/Light/Quinary" width={scale(7)} height={scale(12)} key={scale(7)} />
      </View>
    );
  };

  const HeaderAction = ({ zIndex }) => {
    return (
      <View style={[{ position: 'absolute', right: scale(20), zIndex }, !isWeb && { top: scale(30) }]}>
        <TouchableElement
          onPress={() => {
            Popup({
              Component: (p) => <ClampingToolDetails {...{ ...p, params, newTool: true }} />,
            });
          }}
        >
          {({ boxStyle }) => (
            <View style={[boxStyle]}>
              <Svg icon="plus" width={scale(isWeb ? 21 : 16)} height={scale(isWeb ? 21 : 16)} color={'Link/Light/Special'} />
            </View>
          )}
        </TouchableElement>
      </View>
    );
  };

  return (
    <View style={{ height: '100%', width: '100%', backgroundColor: C('Background/Light/Detail'), alignItems: 'center' }}>
      <View
        style={{
          width: panelViewMode ? '100%' : width,
        }}
      >
        {!panelViewMode && (
          <AnimatedHeader
            {...{
              backText: params?.ncFile,
              actions: [{ component: HeaderAction, key: 'HeaderAction' }],
              text: i18n.t('Tools'),
              C,
              animated: false,
              back: true,
              backgroundColor: 'Background/Light/Detail',
              borderBottomWidth: 0,
            }}
          />
        )}
        <View style={{ width: '100%', height: '100%', paddingTop: scale(panelViewMode ? 0 : 90) }}>
          <ScrollView contentContainerStyle={{ width: '100%', height: '100%', alignItems: 'center' }}>
            <View
              style={{
                width: panelViewMode ? '100%' : width,
                paddingBottom: scale(panelViewMode ? 0 : 70),
              }}
            >
              <View style={{ marginTop: scale(panelViewMode ? 0 : 14), paddingHorizontal: scale(panelViewMode ? 0 : 36) }}>
                <AnimatedTable
                  {...{
                    C,
                    font,
                    scale,
                    loaded,
                    array: clampingTools.map((item) => ({
                      ...item,
                      toolName: `T${item.toolNumber} ${item.toolName}`,
                      description: item?.toolDescription,
                      stickoutMM: `${item?.toolStickoutMM ?? 0}${i18n.t('mm')}`,
                      machiningDurationString:
                        item.machiningDuration > 0 ? formatTimeEvent(convertTimeLetter(item.machiningDuration)) : '0' + i18n.t('s'),
                    })),
                    headerSize: 50,
                    lineSize: 43,
                    showMoreSize: 43,
                    baseCount: 5,
                    showMoreText: i18n.t('SHOW ALL'),
                    showMoreArrow: false,
                    onPress: (tool) => {
                      Popup({
                        Component: (p) => <ClampingToolDetails {...{ ...p, clampingTool: tool, params, newTool: false }} />,
                      });
                    },
                    config: [
                      {
                        key: 'toolName',
                        title: 'Tool',
                        sort: true,
                        width: '20%',
                        color: C('Label / Light / Primary'),
                        titleColor: C('Label / Light / Secondary'),
                      },
                      {
                        key: 'description',
                        title: 'Description',
                        sort: true,
                        width: '20%',
                        color: C('Label / Light / Secondary'),
                        titleColor: C('Label / Light / Secondary'),
                      },
                      {
                        key: 'memo',
                        title: 'Memo',
                        sort: true,
                        width: '20%',
                        color: C('Label / Light / Secondary'),
                        titleColor: C('Label / Light / Secondary'),
                      },
                      {
                        key: 'stickoutMM',
                        title: 'Stickout',
                        sort: true,
                        width: '20%',
                        color: C('Label / Light / Secondary'),
                        titleColor: C('Label / Light / Secondary'),
                      },
                      {
                        key: 'machiningDurationString',
                        title: 'Time',
                        sort: true,
                        width: '20%',
                        color: C('Label / Light / Secondary'),
                        titleColor: C('Label / Light / Secondary'),
                      },
                      {
                        function: ArrowComponent,
                        title: '',
                      },
                    ],
                  }}
                />
              </View>
            </View>
          </ScrollView>
        </View>
      </View>
    </View>
  );
};
